<template>
    <div id="container0" :class="(smallHeader) ? 'scrolled' : 'top'">
        <Header/>
        <div class="container">
            <div id="main">
                <!--
                <router-view v-if="$route.meta.type !== 'work'" :key="$route.fullPath"></router-view>
                <Work v-if="showWork" v-show="$route.meta.type === 'work'"/>
                -->
                <router-view  :key="routeKey"></router-view>
            </div>
            <Popup/>
            <!--<DownArrow/>-->
            <Footer/>
            <TransitionOverlay></TransitionOverlay>
        </div>
    </div>
</template>

<script>
//import Work from './components/pages/Work'
import Header from './components/framework/Header'
import Footer from './components/framework/Footer'
import Popup from './components/framework/Popup'
//import DownArrow from './components/framework/DownArrow'
import TransitionOverlay from './components/framework/TransitionOverlay'
import { isMobile, browserName, osName } from 'mobile-device-detect'
import {mapState} from "vuex";
// import { detect } from 'detect-browser'
export default {
    name: 'App',
    components: {
        //Work,
        Header,
        Footer,
        //DownArrow,
        Popup,
        TransitionOverlay
    },
    data() {
        return {
            window:window,
            document:document,
            showBlocker:false,
            showWork: false,
        }
    },
    computed: {
        ...mapState({
            smallHeader: state => state.smallHeader,
        }),
        routeKey() {
            return `${this.$route.fullPath}-${Date.now()}`;
        }
    },
    watch: {
        $route(to) {
            let del = 7000
            if (to.meta.type === 'work') {
                del = 0
            }
            // load in work on a delay for the first time because its heavier
            if (!this.showWork) {
                setTimeout(this.showWorkYes, del)
            } else {
                //setTimeout(window.dispatchEvent(new Event('resize')), 100)
                setTimeout(window.dispatchEvent(new Event('resize')), 500)
            }
        }
    },
    mounted() {
        //console.clear()
        let t = "%c ✨ We Can Be Heroes - https://heroic.art ✨"
        let n = ["font-size: 12px", "color: #fffce1", "font-family: monospace", "background: #0e100f", "display: inline-block", "padding: 1rem 3rem", "border: 1px solid #fffce1", "border-radius: 4px;"].join(";");
        console.info(t, n)

        // https://www.npmjs.com/package/mobile-device-detect
        let bname = String(browserName).toLowerCase()
        bname = bname.replace('mobile', '')
        bname = bname.replace(' ', '')
        this.document.body.className += ' browser-'+ bname

        let osname = String(osName).toLowerCase()
        this.document.body.className += ' browser-os-'+ osname

        if (isMobile) {
            this.document.body.className += ' device-mobile'
        } else {
            this.document.body.className += ' device-notmobile'
        }


        this.window.addEventListener('resize', this.resize)
        this.resize()
        if (isMobile) {
            this.window.addEventListener('orientationchange', this.siteOrientationChange)
            //this.siteOrientationChange()
        }

    },
    methods: {
        showWorkYes() {
          this.showWork=true
            //window.dispatchEvent(new Event('resize'));
            //setTimeout(window.dispatchEvent(new Event('resize')), 100)
            setTimeout(window.dispatchEvent(new Event('resize')), 500)
        },
        resize () {
            // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
            let vh = this.window.innerHeight * 0.01;
            this.document.documentElement.style.setProperty('--vh', `${vh}px`)

            //this.siteOrientationChange()
        },
        siteOrientationChange() {
            if (isMobile) {
                this.resize()
            }
        }
        /*
        siteOrientationChange() {
            if (isMobile) {
                let t = this
                setTimeout(function () {
                    t.showBlocker = (t.window.innerWidth > t.window.innerHeight)
                    //if( (window.orientation === 90 && $( window ).width() < 780) || (window.orientation === -90 && $( window ).width() < 780) ) // Landscape {
                }.bind(t), 100)
            }
        },

         */
    }
}
</script>
<style lang="scss">
@import "./assets/scss/app.scss";
</style>
